export default function formatMoney(amount, allowShortForm = false) {
    let decimalCount = 2;
    if (Number.isInteger(amount) && allowShortForm) {
        decimalCount = 0;
    }

    const negativeSign = amount < 0 ? "-" : "";

    const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
        negativeSign +
        (j ? i.substr(0, j) + "," : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",") +
        (decimalCount
            ? "." +
              Math.abs(amount - i)
                  .toFixed(decimalCount)
                  .slice(2)
            : "")
    );
}
